import React, {useEffect, useRef} from "react";
import "../styles/footer.scss"
import Mail from "../assets/svg/email.svg"
import Phone from "../assets/svg/phone.svg"
import Copyright from "../assets/svg/cc.svg"
import Insta from "../assets/svg/insta.svg"
import WhatsApp from "../assets/svg/whatsapp.svg"
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png"

function Footer(){
    const navigate = useNavigate();
  
    // Create a ref for the container you want to listen on
    const navRef = useRef(null);
  
    useEffect(() => {
      // If navRef hasn't been attached yet, bail out
      if (!navRef.current) return;
  
      // Clean up function can be empty since we're not adding listeners
      return () => {
      };
    }, []);
  
    const handleClick = (route) => {
      navigate(route);
    };
    return(
        <>
            <div className="footerbody flex-row">
                <div className="footercontent flex-column">
                    <div className="tophalf flex-row">
                        <div className="topleftmain flex-column">
                            <img src={Logo} alt="Elza Text" className="footerlogo img"/>
                                <div className="flex-row center">
                                    <img src={Mail} alt="Mail" className="mailsvg svg"/>
                                    <p>info@freshaircare.nl</p>
                                </div>
                                <div className="flex-row center">
                                    <img src={Phone} alt="PhoneLogo" className="phonesvg svg"/>
                                    <p>085 203 34 95</p>
                                </div>
                        </div>
                        <div className="toprightmain flex-row">
                            <div className="footerinformation flex-column">
                                <p className="bold img footer.p.tag">Shop</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/Tarieven")}>Tarieven</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/Offerteaanvragen")}>Offerte</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/Contact")}>Contact</p>
                            </div>
                            <div className="footerinformation flex-column">
                                <p className="bold img footer.p.tag">Info</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/Mechanische-ventilatie")}>Mechanische Ventilatie</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/WTW-systemen")}>WTW Systemen</p>
                                <p className="thin footer-link footer.p.tag" onClick={() => handleClick("/Dakventilatie")}>Dakventilatie</p>
                            </div>
                            <div className="footerinformation flex-column">
                                <p className="bold img footer.p.tag">Tijden</p>
                                <div className="flex-row">
                                    <p className="bold footer.p.tag">Ma-Vr</p>
                                    <p className="thin footer.p.tag">08:30-18:00</p>
                                </div>
                                <div className="flex-row">
                                    <p className="bold footer.p.tag">Za</p>
                                    <p className="thin footer.p.tag">12:00-18:00</p>
                                </div>
                                <div className="flex-row">
                                    <p className="bold footer.p.tag">Zo</p>
                                    <p className="thin footer.p.tag">Gesloten</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="line"></div>
                    <div className="underline flex-row">
                        <div className="trademark flex-row svg">
                            <img src={Copyright} alt="TrademarkSign"/>
                            <p className="thin footer.p.tag">2025 Fresh Air Care</p>
                        </div>
                        <div className="socials flex-row img">
                            <a
                                href="https://www.instagram.com/freshaircare.nl/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our Instagram page"
                                className="social-link"
                            >
                                <img 
                                    src={Insta} 
                                    alt="Instagram" 
                                />
                            </a>
                            <a
                                href="https://wa.me/31852033495?text=Hallo%20FreshAirCare,%20ik%20heb%20een%20vraag%20over%20ventilatie."
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Contact us on WhatsApp"
                                className="social-link"
                            >
                                <img 
                                    src={WhatsApp} 
                                    alt="WhatsApp" 
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer